import { LngLat, Offset } from 'maplibre-gl';
import { Popup } from 'react-map-gl/maplibre';
import { theme } from '~/theme';

interface Props {
  offset?: Offset;
  position: LngLat;
  key: string;
  children: JSX.Element;
  closeOnClick?: boolean;
}

export const PopupWrapper = ({
  position,
  key,
  children,
  offset = [0, 0] as Offset,
  // Reverse the default of close on click for the popup; most of the time we want it false
  closeOnClick = false,
}: Props) => {
  return (
    <Popup
      anchor="bottom"
      offset={offset}
      closeButton={false}
      closeOnClick={closeOnClick}
      latitude={position.lat}
      longitude={position.lng}
      key={key}
      focusAfterOpen={false}
      style={{ padding: theme.spacing(2) }}
      maxWidth="412px"
    >
      {children}
    </Popup>
  );
};
